import React, {useRef} from 'react';
import {motion} from 'framer-motion';
import {ContactCTA, Footer, LazyImage, Navbar} from '../../components';
import styles from './Services.module.css';

const HERO_BG = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773523495/0fc9efeadb9ca320f5d2b88bdefc37a852cc9577_1_c4pub3.jpg';


const fadeUp = (delay = 0) => ({
    hidden: {opacity: 0, y: 40},
    visible: {opacity: 1, y: 0, transition: {duration: 0.6, ease: 'easeOut', delay}},
});

const SERVICES = [
    {
        id: 1,
        title: 'Road Construction & Infrastructure Development',
        desc: 'Our experience is not limited to asphalt paving, concrete concrete paving and the aggregate sub base. We also perform a majority of the associated works such as: water mains, sewers, culvert repairs, earthworks, concrete sidewalks and curb/ gutter formation. ',
        // desc: 'Our experience is not limited to just asphalt and concrete paving and the aggregate sub-base. We also perform the majority of the associated works such as: water-mains, sewers, culvert repairs, earthworks, concrete sidewalks, and curb & gutter formation.',
        bg: '#faebe9',
        images: [
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773523578/Frame_1000003454_erzbf7.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773523651/Frame_1000003465_ldppty.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773523863/19481c9f5990ded5802c8ad8d67ec9596b3c657e_1_nf2zqs.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773524604/Frame_1000003454_1_oymu9z.jpg',
        ],
    },
    {
        id: 2,
        title: 'Production Of Thermoplastic Road Marking Paint',
        desc: 'We provide all inclusive Road Furniture which includes- Provision and installation of Solar Lights/ CCTV, Road Signs, Highway Signs, Traffic lights, Speed bumps, Reflective Cat Eye Studs and Traffic Data Counter Classifiers.',
        // desc: 'We manufacture high-grade thermoplastic road marking paint formulated for durability, retro reflectivity, and environmental resistance. Our materials meet international standards and are deployed across federal and state highway projects nationwide.',
        bg: '#fafafa',
        images: [
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773524670/1fae49dd-6f18-4e86-a5f4-9c67c0504cc0_l95vti.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773524734/072de619-868c-411f-bc62-8bca67c4eda8_hvorpx.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773598115/1b2d7e03-c8ff-4fc8-b97b-b0e27a65da6d_yuw5qi.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773598192/aa608c14-d2a0-4d94-8363-db8fed1bcfca_dbhjfa.jpg',
        ],
    },
    {
        id: 3,
        title: 'Traffic Management & Road Safety Solutions',
        desc: 'We provide all inclusive Road Furniture which includes- Provision and installation of Solar Lights/ CCTV, Road Signs, Highway Signs, Traffic lights, Speed bumps, Reflective Cat Eye Studs and Traffic Data Counter Classifiers.',
        // desc: 'To be the foremost catalyst for sustainable infrastructure, building a future where engineering excellence and environmental value exist in perfect alignment. We strive to set the global benchmark for "Green" urban projects, transforming how the world builds, moves, and powers itself.',
        bg: '#fff6e8',
        images: [
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773598248/f4aae40e-d87e-42c1-a62d-63741179aadc_lpxv7m.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773598313/8c78ea74-4c64-4afd-a479-8c729ee5b0f9_ge74po.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773598357/50230cf6-f072-4a4e-ba87-b55976f3bb2e_lrdyct.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773598417/26b4e6a606b2994e300529d3a9ffaa8430d51633_1_ysbsow.jpg',
        ],
    },
    {
        id: 4,
        title: 'Road Marking & Signage Systems',
        desc: 'From thermoplastic line marking to retro reflective road signs, we deploy comprehensive road marking and signage systems that guide road users safely. Our teams are equipped to handle federal highway standards as well as urban municipal requirements.',
        bg: '#fafafa',
        images: [
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773599754/b7511241-8536-40c4-a4a2-cb5bf3b4aa26_ie7pbx.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773599799/29e9e852-337b-4ffb-a50a-8a3ef01f2331_phi6y5.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773599843/5a3a6e79-f78b-4963-8b65-6b8d04e4e1dd_vr0hwt.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773599895/6bd9cc52-389b-4cb9-ad57-6211b90cbaa9_lhkzrb.jpg',
        ],
    },
    {
        id: 5,
        title: 'Smart Traffic & Solar Infrastructure',
        desc: 'We integrate intelligent traffic management systems with solar-powered energy solutions, creating self-sustaining infrastructure. From solar hybrid traffic signals to street lighting powered by renewable energy, we are engineering a smarter, greener Nigeria.',
        bg: '#faebe9',
        images: [
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773599954/ba68b07d-ee48-4dfa-9690-d5fbdacbdc1d_fmxcjh.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773600018/8ab45073-2888-49cf-8eb7-a8742651752c_lni2ln.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773600055/62eecdd0-0308-4088-be7e-546c06bec734_gvklsm.jpg',
            'https://res.cloudinary.com/dhjzovpof/image/upload/v1773600146/f79d958f-63b9-4db8-abb9-d1c1c526772e_nehiqb.jpg',
        ],
    },
];

function ServiceSection({svc}) {
    const galleryRef = useRef(null);

    const scroll = (dir) => {
        if (galleryRef.current) {
            // scroll by one card width + gap (688 = 664 + 24)
            galleryRef.current.scrollBy({left: dir * 688, behavior: 'smooth'});
        }
    };

    return (
        <motion.section
            className={styles.serviceSection}
            style={{background: svc.bg}}
            variants={fadeUp(0)}
            initial="hidden"
            whileInView="visible"
            viewport={{once: true, amount: 0.15}}
        >
            <div className={styles.serviceHeader}>
                <div className={styles.serviceHeaderLeft}>
                    <h3 className={styles.serviceTitle}>{svc.title}</h3>
                    <p className={styles.serviceDesc}>{svc.desc}</p>
                </div>
                <div className={styles.navButtons}>
                    <button
                        className={styles.navBtnLeft}
                        onClick={() => scroll(-1)}
                        aria-label="Previous"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M15 18L9 12L15 6" stroke="#404040" strokeWidth="2" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <button
                        className={styles.navBtnRight}
                        onClick={() => scroll(1)}
                        aria-label="Next"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M9 18L15 12L9 6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>

            <div className={styles.galleryTrack} ref={galleryRef}>
                {svc.images.map((src, i) => (
                    <div key={i} className={styles.galleryItem}>
                        <LazyImage src={src} alt="" className={styles.galleryImg}/>
                        <div className={styles.galleryOverlay} aria-hidden="true"/>
                    </div>
                ))}
            </div>
        </motion.section>
    );
}

export default function Services() {
    return (
        <div className={styles.page}>
            <Navbar theme="light" cta="Contact Us" ctaTo="/contact"/>

            {/* ── HERO ──────────────────────────────────────────── */}
            <section className={styles.hero}>
                <div className={styles.heroBg} aria-hidden="true">
                    <LazyImage src={HERO_BG} alt=""/>
                    <div className={styles.heroGradient}/>
                </div>
                <div className={styles.heroLabel}>
                    <h1 className={styles.heroTitle}>SERVICES</h1>
                </div>
            </section>

            {/* ── WHAT WE DO ────────────────────────────────────── */}
            <motion.section
                className={styles.whatWeDo}
                variants={fadeUp(0)}
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.3}}
            >
                <h2 className={styles.whatWeDoTitle}>What We Do</h2>
                <p className={styles.whatWeDoDesc}>
                    TektronPlus offers engineering services and environmentally conscious energy solutions
                    related to new and existing structures. We are able to supply all materials, labour, and
                    equipment needed for road construction. Controlling all aspects of the project internally
                    results in tighter control on quality and a better end-product for our customers.
                </p>
            </motion.section>

            {/* ── SERVICE SECTIONS ──────────────────────────────── */}
            {SERVICES.map((svc) => (
                <ServiceSection key={svc.id} svc={svc}/>
            ))}


            <ContactCTA/>
            <Footer/>
        </div>
    );
}
